import Lockbody from 'helpers/lockbody';

const navId = 'navigation';
const lockClass = 'Nlock_sc';

export const toggleMenu = () => {
    const navigation = window.document.getElementById(navId);
    Lockbody();
    navigation?.classList.toggle(lockClass);
};

export const closeMenu = () => {
    const navigation = window.document.getElementById(navId);
    const isMenuOpened = navigation?.classList.contains(lockClass);

    if (isMenuOpened) {
        Lockbody();
        navigation?.classList.remove(lockClass);
    }
};
